function initialState() {
    return {
        status: true,
        rawDataValid: true,
    }
}

export default {
    state: initialState(),
    getters: {
        SAVE_STATUS: state => state.status,
        IS_RAW_VALID: state => state.rawDataValid,
    },
    mutations: {
        SET_SAVE_STATUS(state, payload) {
            state.status = payload;
        },
        SET_IS_RAW_VALID(state, payload) {
            state.rawDataValid = payload;
        },
    },
    actions: {
        UPDATE_SAVE_STATUS: ({commit}, payload) => {
            commit('SET_SAVE_STATUS', payload);
        },
    }
}
